/** Asset 360 / Site 360 (tracker 39), under assets:report360. See locales/en-US/report360.ts. */
export const report360 = {
  ui: {
    finding: "النتيجة",
    versionPrepared: "الإصدار {{version}} · أُعدّ في {{date}}",
    kindAsset: "Asset 360",
    kindSite: "Site 360",
    kindVersion: "{{kind}} · الإصدار {{version}}",
    preparedFor: "أُعدّ لـ {{name}}",
    writtenFor: "مكتوب لـ: {{reader}}",
    prepared: "أُعدّ في {{date}}",
    figuresAsOf: "الأرقام حتى {{date}}",
    wordsByAi: "الشروح كتبها الذكاء الاصطناعي (Google Gemini) من أرقام التطبيق. لا يغيّر الذكاء الاصطناعي أي رقم.",
    wordsByApp: "كتبه التطبيق من سجلاتك.",
    verdictTitle: "الحكم العام",
    contents: "المحتويات",
    contentsLine: "{{number}}. {{title}}",
    contentsTail: "ثم: خطة العمل، جودة البيانات، حول هذا التقرير.",
    summaryTitle: "الملخص التنفيذي",
    keyFindings: "أهم النتائج",
    doFirst: "ما يجب فعله أولاً",
    bullet: "• {{text}}",
    scorecardTitle: "بطاقة المؤشرات",
    noData: "لا توجد بيانات بعد",
    change30d: "{{value}} خلال 30 يومًا",
    sectionTitle: "{{number}}. {{title}}",
    whatItMeans: "ماذا يعني ذلك",
    actionsTitle: "خطة العمل",
    actionsNone: "لا شيء يحتاج إلى إجراء الآن.",
    priority1: "الآن",
    priority2: "التالي",
    priority3: "عند الإمكان",
    due_zero: "خلال {{count}} أيام",
    due_one: "خلال يوم واحد",
    due_two: "خلال {{count}} أيام",
    due_few: "خلال {{count}} أيام",
    due_many: "خلال {{count}} يوم",
    due_other: "خلال {{count}} يوم",
    raiseJob: "إنشاء مهمة",
    raiseInspection: "بدء فحص",
    open: "فتح",
    dataQualityTitle: "جودة البيانات",
    dataQualityIntro: "إلى أي مدى يمكن لهذا التقرير الاعتماد على سجلاتك. النواقص تقلل موثوقية كل قسم.",
    cannotJudge: "ما لم يتمكن التقرير من تقييمه",
    getMoreTitle: "استفد أكثر من هذا التقرير",
    getMoreIntro: "أنت وحدك ترى هذا. لا يظهر أبدًا فيما تشاركه.",
    aboutTitle: "حول هذا التقرير",
    coverage: "{{recorded}} من أصل {{total}} أنواع من السجلات متوفرة.",
    coverageMissing: "لم يُسجَّل بعد: {{list}}.",
    aboutAsset_zero: "الدرجات من أرقام الليلة؛ المهام والفحوصات تغطي آخر {{count}} أيام.",
    aboutAsset_one: "الدرجات من أرقام الليلة؛ المهام والفحوصات تغطي آخر يوم.",
    aboutAsset_two: "الدرجات من أرقام الليلة؛ المهام والفحوصات تغطي آخر {{count}} أيام.",
    aboutAsset_few: "الدرجات من أرقام الليلة؛ المهام والفحوصات تغطي آخر {{count}} أيام.",
    aboutAsset_many: "الدرجات من أرقام الليلة؛ المهام والفحوصات تغطي آخر {{count}} يوم.",
    aboutAsset_other: "الدرجات من أرقام الليلة؛ المهام والفحوصات تغطي آخر {{count}} يوم.",
    aboutSite_zero: "الدرجات من الملخص الليلي للموقع؛ المهام تغطي آخر {{count}} أيام.",
    aboutSite_one: "الدرجات من الملخص الليلي للموقع؛ المهام تغطي آخر يوم.",
    aboutSite_two: "الدرجات من الملخص الليلي للموقع؛ المهام تغطي آخر {{count}} أيام.",
    aboutSite_few: "الدرجات من الملخص الليلي للموقع؛ المهام تغطي آخر {{count}} أيام.",
    aboutSite_many: "الدرجات من الملخص الليلي للموقع؛ المهام تغطي آخر {{count}} يوم.",
    aboutSite_other: "الدرجات من الملخص الليلي للموقع؛ المهام تغطي آخر {{count}} يوم.",
    aboutAi: "كتب الذكاء الاصطناعي الملخص والشروح للقارئ المختار. كل رقم وتقييم ونتيجة من التطبيق.",
    highRisk: "خطر مرتفع",
    nothingToShow: "لا شيء لعرضه بعد.",
    labelValue: "{{label}}: {{value}}",
    whereItSits: "مكانه",
    dependsOn: "يعتمد على",
    serves: "يخدم",
    none: "لا شيء مسجّل",
    singlePoints: "نقطة تعطّل وحيدة: {{names}}",
    hiddenLinks_zero: "{{count}} روابط إضافية لا يمكنك فتحها",
    hiddenLinks_one: "رابط إضافي لا يمكنك فتحه",
    hiddenLinks_two: "{{count}} روابط إضافية لا يمكنك فتحها",
    hiddenLinks_few: "{{count}} روابط إضافية لا يمكنك فتحها",
    hiddenLinks_many: "{{count}} رابطًا إضافيًا لا يمكنك فتحه",
    hiddenLinks_other: "{{count}} رابطًا إضافيًا لا يمكنك فتحه",
    prepareTitle: "إعداد التقرير",
    readerLabel: "لمن هو؟",
    readerA11y: "كتابة التقرير لـ: {{reader}}",
    hideNames: "إخفاء أسماء المقاولين",
    hideNamesHint: "يعرض المقاولين باسم المقاول A وB وهكذا.",
    preparedForLabel: "أُعدّ لـ (اختياري)",
    preparedForPlaceholder: "مثلاً: شركة الميناء العقارية",
    storyTitle: "نسخة الذكاء الاصطناعي",
    storyHint: "يعيد Google Gemini كتابة الملخص وكل شرح لقارئك باللغة التي تختارها. لا يغيّر أي رقم.",
    languageLabel: "اللغة",
    focusLabel: "ركّز الذكاء الاصطناعي على",
    pickFocus: "اختر قسمًا واحدًا على الأقل ليركّز عليه الذكاء الاصطناعي.",
    weakData: "جودة البيانات ضعيفة ({{score}} من 100). سيذكر الذكاء الاصطناعي ما لا يستطيع تقييمه بدلاً من التخمين.",
    generate: "كتابة نسخة الذكاء الاصطناعي",
    chargedWhenWritten: "يُخصم الرصيد فقط عند كتابة التقرير. إذا فشل، لا يُحتسب شيء.",
    queuedTitle: "نسختك من الذكاء الاصطناعي في قائمة الانتظار",
    queuedBody: "رقم {{position}} في قائمة الانتظار. يمكنك مغادرة هذه الصفحة: ستصلك إشعار عندما تكون جاهزة.",
    runningTitle: "جارٍ كتابة نسختك من الذكاء الاصطناعي…",
    runningBody: "يستغرق ذلك عادةً أقل من دقيقة. يمكنك مغادرة هذه الصفحة: سيصلك إشعار عندما تكون جاهزة.",
    failedTitle: "تعذّرت كتابة نسخة الذكاء الاصطناعي",
    failedBody: "لم يُحتسب أي شيء. حاول مرة أخرى بعد قليل.",
    joined: "طلب شخص آخر هذا التقرير بالفعل، لذا ستحصلان على التقرير نفسه.",
    showingAi: "نسخة الذكاء الاصطناعي {{version}}، كُتبت في {{date}}",
    showingApp: "نسخة التطبيق لهذا القارئ",
    showApp: "عرض نسخة التطبيق",
    showAi: "عرض نسخة الذكاء الاصطناعي",
    loading: "جارٍ إعداد التقرير…",
    loadFailed: "تعذّر فتح التقرير.",
    busy: "التقارير مشغولة الآن. حاول مرة أخرى بعد قليل.",
    retry: "إعادة المحاولة",
    requestFailedTitle: "تعذّر طلب نسخة الذكاء الاصطناعي",
    earlierTitle: "قبل Asset 360",
    earlierHint: "تقارير بالذكاء الاصطناعي كُتبت قبل Asset 360 وSite 360. اضغط على تاريخ لقراءته.",
    shareTitle: "{{kind}}: {{name}}",
  },
  reader: {
    asset_manager: "مدير الأصول",
    client: "العميل",
    landlord: "المالك",
    site_manager: "مدير الموقع",
    investor: "المستثمر",
  },
  readerHint: {
    asset_manager: "الصورة الكاملة، من المحيط حتى المهام، بكل الأقسام.",
    client: "المهام والمقاولون أولاً: ما أُنجز، وبأي جودة، وهل في الموعد.",
    landlord: "الامتثال والمخاطر أولاً. أسماء المقاولين مخفية ما لم تُظهرها.",
    site_manager: "المهام والحالة أولاً، مع خطة العمل مباشرة بعد الملخص.",
    investor: "نحو صفحتين: الحكم العام، بطاقة المؤشرات، المخاطر، الامتثال وأهم الإجراءات.",
  },
  rating: {
    on_track: "على المسار",
    watch: "للمتابعة",
    needs_attention: "يحتاج إلى اهتمام",
  },
  confidence: {
    high: "الموثوقية: عالية",
    medium: "الموثوقية: متوسطة",
    low: "الموثوقية: منخفضة",
  },
  dqBand: {
    strong: "قوية",
    fair: "مقبولة",
    weak: "ضعيفة",
  },
  dimension: {
    complete: "مكتملة",
    current: "محدّثة",
    evidenced: "موثّقة",
    connected: "مترابطة",
    consistent: "متسقة",
  },
  scorecard: {
    asset: {
      compliance: "الامتثال",
      risk: "المخاطر",
      condition: "الحالة",
      inspections_on_time: "الفحوصات في موعدها",
      right_first_time: "صحيح من أول مرة",
      overdue_work: "مهام متأخرة",
    },
    site: {
      compliance: "الامتثال",
      risk: "متوسط المخاطر",
      condition: "الحالة",
      inspections_on_time: "أصول فُحصت هذا العام",
      right_first_time: "صحيح من أول مرة",
      overdue_work: "مهام متأخرة",
    },
  },
  section: {
    environment: "مكانه وما يحيط به",
    compliance: "الامتثال",
    risk: "المخاطر",
    condition: "الحالة والفحوصات",
    work: "المهام",
    contractors: "المقاولون",
    property: "العقار",
    areas: "المباني والمناطق",
    inspections: "الفحوصات",
    siteRisk: "المخاطر في الموقع كله",
  },
  finding: {
    environment: {
      noSite: "غير مرتبط بأي موقع، لذا محيطه غير معروف.",
      site: "يقع في {{site}}، حيث {{atRisk}} من أصل {{assets}} أصول معرّضة للخطر و{{overdue}} مهام متأخرة.",
      siteNoSummary: "يقع في {{site}}، الذي ليس له ملخص ليلي بعد.",
    },
    compliance: {
      expired_zero: "انتهت صلاحية {{count}} شهادات أو مستندات.",
      expired_one: "انتهت صلاحية شهادة أو مستند واحد.",
      expired_two: "انتهت صلاحية {{count}} شهادات أو مستندات.",
      expired_few: "انتهت صلاحية {{count}} شهادات أو مستندات.",
      expired_many: "انتهت صلاحية {{count}} شهادة أو مستند.",
      expired_other: "انتهت صلاحية {{count}} شهادة أو مستند.",
      expiring_zero: "تنتهي صلاحية {{count}} شهادات خلال الأيام الستين القادمة.",
      expiring_one: "تنتهي صلاحية شهادة واحدة خلال الأيام الستين القادمة.",
      expiring_two: "تنتهي صلاحية {{count}} شهادات خلال الأيام الستين القادمة.",
      expiring_few: "تنتهي صلاحية {{count}} شهادات خلال الأيام الستين القادمة.",
      expiring_many: "تنتهي صلاحية {{count}} شهادة خلال الأيام الستين القادمة.",
      expiring_other: "تنتهي صلاحية {{count}} شهادة خلال الأيام الستين القادمة.",
      noDocuments: "الامتثال عند {{score}}، لكن لا توجد شهادات محفوظة تثبته.",
      noFigures: "لا توجد أرقام امتثال محفوظة بعد.",
      ok_zero: "الامتثال عند {{score}}، مع {{count}} مستندات محفوظة ولا شيء منتهي الصلاحية.",
      ok_one: "الامتثال عند {{score}}، مع مستند واحد محفوظ ولا شيء منتهي الصلاحية.",
      ok_two: "الامتثال عند {{score}}، مع {{count}} مستندات محفوظة ولا شيء منتهي الصلاحية.",
      ok_few: "الامتثال عند {{score}}، مع {{count}} مستندات محفوظة ولا شيء منتهي الصلاحية.",
      ok_many: "الامتثال عند {{score}}، مع {{count}} مستندًا محفوظًا ولا شيء منتهي الصلاحية.",
      ok_other: "الامتثال عند {{score}}، مع {{count}} مستندًا محفوظًا ولا شيء منتهي الصلاحية.",
      site: "الامتثال في الموقع كله عند {{score}}.",
      siteExpired_zero: "انتهت صلاحية {{count}} مستندات في الموقع.",
      siteExpired_one: "انتهت صلاحية مستند واحد في الموقع.",
      siteExpired_two: "انتهت صلاحية {{count}} مستندات في الموقع.",
      siteExpired_few: "انتهت صلاحية {{count}} مستندات في الموقع.",
      siteExpired_many: "انتهت صلاحية {{count}} مستندًا في الموقع.",
      siteExpired_other: "انتهت صلاحية {{count}} مستندًا في الموقع.",
    },
    condition: {
      health: "الحالة {{score}} ({{band}}). أيام منذ آخر فحص: {{days}}.",
      inspected: "لا توجد درجة حالة محفوظة بعد. أيام منذ آخر فحص: {{days}}.",
      neverInspected: "لم يُفحص قط، لذا حالته الحالية غير معروفة.",
      overdueChecks_zero: "{{count}} فحوصات مجدولة متأخرة.",
      overdueChecks_one: "فحص مجدول واحد متأخر.",
      overdueChecks_two: "{{count}} فحوصات مجدولة متأخرة.",
      overdueChecks_few: "{{count}} فحوصات مجدولة متأخرة.",
      overdueChecks_many: "{{count}} فحصًا مجدولاً متأخرًا.",
      overdueChecks_other: "{{count}} فحصًا مجدولاً متأخرًا.",
    },
    contractors: {
      none: "لم يعمل أي مقاول هنا خلال هذه الفترة.",
      summary_zero: "أنجز {{count}} مقاولين {{jobs}} مهام. الأكثر نشاطًا: {{busiest}}.",
      summary_one: "أنجز مقاول واحد {{jobs}} مهام: {{busiest}}.",
      summary_two: "أنجز {{count}} مقاولين {{jobs}} مهام. الأكثر نشاطًا: {{busiest}}.",
      summary_few: "أنجز {{count}} مقاولين {{jobs}} مهام. الأكثر نشاطًا: {{busiest}}.",
      summary_many: "أنجز {{count}} مقاولاً {{jobs}} مهام. الأكثر نشاطًا: {{busiest}}.",
      summary_other: "أنجز {{count}} مقاولاً {{jobs}} مهام. الأكثر نشاطًا: {{busiest}}.",
    },
    inspections: {
      noSummary: "لا يوجد ملخص فحوصات محفوظ لهذا الموقع بعد.",
      site: "فُحص {{inspected}} من أصل {{assets}} أصول هذا العام. وجد {{failed}} من أصل {{inspections}} فحوصات في آخر 90 يومًا مشكلات.",
    },
    property: {
      noSummary: "يضم الموقع {{assets}} أصول. لا يوجد ملخص ليلي محفوظ بعد.",
      summary: "يضم الموقع {{assets}} أصول. {{atRisk}} معرّضة للخطر و{{open}} مهام مفتوحة.",
    },
    risk: {
      level: "المخاطر {{level}} ({{score}} من 25).",
      neighbours_zero: "المخاطر {{level}} ({{score}} من 25)، و{{count}} أصول مرتبطة عالية المخاطر.",
      neighbours_one: "المخاطر {{level}} ({{score}} من 25)، وأصل مرتبط واحد عالي المخاطر.",
      neighbours_two: "المخاطر {{level}} ({{score}} من 25)، و{{count}} أصول مرتبطة عالية المخاطر.",
      neighbours_few: "المخاطر {{level}} ({{score}} من 25)، و{{count}} أصول مرتبطة عالية المخاطر.",
      neighbours_many: "المخاطر {{level}} ({{score}} من 25)، و{{count}} أصلاً مرتبطًا عالي المخاطر.",
      neighbours_other: "المخاطر {{level}} ({{score}} من 25)، و{{count}} أصلاً مرتبطًا عالي المخاطر.",
      notAssessed: "لم يُجرَ أي تقييم للمخاطر.",
      singlePoint: "المخاطر {{level}} ({{score}} من 25)، و{{name}} نقطة تعطّل وحيدة.",
      site: "متوسط المخاطر {{level}} ({{score}} من 25). {{atRisk}} أصول معرّضة للخطر.",
      siteNotAssessed: "لم تُقيَّم مخاطر أصول الموقع.",
    },
    work: {
      none: "لم تُنشأ أي مهام خلال آخر 12 شهرًا.",
      ok: "أُنجزت {{done}} مهام خلال آخر 12 شهرًا، دون تأخير أو إرجاع.",
      overdue_zero: "{{count}} مهام متأخرة. أُنجزت {{done}} مهام خلال آخر 12 شهرًا.",
      overdue_one: "مهمة واحدة متأخرة. أُنجزت {{done}} مهام خلال آخر 12 شهرًا.",
      overdue_two: "{{count}} مهام متأخرة. أُنجزت {{done}} مهام خلال آخر 12 شهرًا.",
      overdue_few: "{{count}} مهام متأخرة. أُنجزت {{done}} مهام خلال آخر 12 شهرًا.",
      overdue_many: "{{count}} مهمة متأخرة. أُنجزت {{done}} مهام خلال آخر 12 شهرًا.",
      overdue_other: "{{count}} مهمة متأخرة. أُنجزت {{done}} مهام خلال آخر 12 شهرًا.",
      rework_zero: "أُرجعت {{count}} مهام من أصل {{done}} مهام منجزة ({{pct}}% صحيحة من أول مرة).",
      rework_one: "أُرجعت مهمة واحدة من أصل {{done}} مهام منجزة ({{pct}}% صحيحة من أول مرة).",
      rework_two: "أُرجعت {{count}} مهام من أصل {{done}} مهام منجزة ({{pct}}% صحيحة من أول مرة).",
      rework_few: "أُرجعت {{count}} مهام من أصل {{done}} مهام منجزة ({{pct}}% صحيحة من أول مرة).",
      rework_many: "أُرجعت {{count}} مهمة من أصل {{done}} مهام منجزة ({{pct}}% صحيحة من أول مرة).",
      rework_other: "أُرجعت {{count}} مهمة من أصل {{done}} مهام منجزة ({{pct}}% صحيحة من أول مرة).",
      siteNone: "لم تُنشأ أي مهام على أصول الموقع خلال آخر 90 يومًا.",
      siteOk: "أُنجزت {{done}} مهام خلال آخر 90 يومًا ولم يُرجع أي منها.",
      siteRework_zero: "أُرجعت {{count}} مهام من أصل {{done}} مهام منجزة خلال آخر 90 يومًا ({{pct}}% صحيحة من أول مرة).",
      siteRework_one: "أُرجعت مهمة واحدة من أصل {{done}} مهام منجزة خلال آخر 90 يومًا ({{pct}}% صحيحة من أول مرة).",
      siteRework_two: "أُرجعت {{count}} مهام من أصل {{done}} مهام منجزة خلال آخر 90 يومًا ({{pct}}% صحيحة من أول مرة).",
      siteRework_few: "أُرجعت {{count}} مهام من أصل {{done}} مهام منجزة خلال آخر 90 يومًا ({{pct}}% صحيحة من أول مرة).",
      siteRework_many: "أُرجعت {{count}} مهمة من أصل {{done}} مهام منجزة خلال آخر 90 يومًا ({{pct}}% صحيحة من أول مرة).",
      siteRework_other: "أُرجعت {{count}} مهمة من أصل {{done}} مهام منجزة خلال آخر 90 يومًا ({{pct}}% صحيحة من أول مرة).",
    },
    areas: {
      none: "لا توجد مبانٍ أو مناطق مسجلة داخل الموقع. المواقع داخله: {{n}}.",
      summary_zero: "{{count}} مبانٍ ومناطق مسجلة. أكبرها {{top}} ويضم {{assets}} أصول.",
      summary_one: "مبنى أو منطقة واحدة مسجلة؛ يضم {{top}} عدد {{assets}} أصول.",
      summary_two: "{{count}} مبانٍ ومناطق مسجلة. أكبرها {{top}} ويضم {{assets}} أصول.",
      summary_few: "{{count}} مبانٍ ومناطق مسجلة. أكبرها {{top}} ويضم {{assets}} أصول.",
      summary_many: "{{count}} مبنى ومنطقة مسجلة. أكبرها {{top}} ويضم {{assets}} أصول.",
      summary_other: "{{count}} مبنى ومنطقة مسجلة. أكبرها {{top}} ويضم {{assets}} أصول.",
    },
  },
  meaning: {
    environment: {
      noSite: "بدون موقع، لا يستطيع التقرير قول ما يحيط به ولا ما تعنيه له مشكلة قريبة.",
      ok: "محيطه في حالة جيدة، لذا يُستبعد أن يزيد ما حوله أي مشكلة هنا سوءًا.",
      siteWeak: "في الموقع مشكلات مفتوحة. قد تؤثر عليه أعمال قريبة، وتصبح مشكلاته أكثر أهمية.",
      neighboursRisk_zero: "{{count}} أصول مرتبطة به عالية المخاطر، لذا قد يصل إليه عطل هناك.",
      neighboursRisk_one: "أصل مرتبط به عالي المخاطر، لذا قد يصل إليه عطل هناك.",
      neighboursRisk_two: "{{count}} أصول مرتبطة به عالية المخاطر، لذا قد يصل إليه عطل هناك.",
      neighboursRisk_few: "{{count}} أصول مرتبطة به عالية المخاطر، لذا قد يصل إليه عطل هناك.",
      neighboursRisk_many: "{{count}} أصلاً مرتبطًا به عالي المخاطر، لذا قد يصل إليه عطل هناك.",
      neighboursRisk_other: "{{count}} أصلاً مرتبطًا به عالي المخاطر، لذا قد يصل إليه عطل هناك.",
    },
    compliance: {
      on_track: "المستندات سليمة. جدّد في الموعد وسيبقى الأمر كذلك.",
      watch: "الامتثال يتراجع. جدّد ما يستحق قبل أن يصبح ملاحظة.",
      needs_attention: "الامتثال يحتاج إلى اهتمام الآن: سيشير إليه أي مفتش أو شركة تأمين.",
      none: "لا توجد أرقام امتثال للحكم بها بعد.",
      expired: "الشهادة المنتهية تعني أن استخدامه قد لا يكون قانونيًا أو مؤمَّنًا حتى تجديدها.",
      noDocuments: "بدون مستندات محفوظة، لا يمكن إثبات الدرجة لمن يسأل.",
      awaitingCheck_zero: "{{count}} مستندات تنتظر التحقق، لذا لا تُحتسب بعد.",
      awaitingCheck_one: "مستند واحد ينتظر التحقق، لذا لا يُحتسب بعد.",
      awaitingCheck_two: "{{count}} مستندات تنتظر التحقق، لذا لا تُحتسب بعد.",
      awaitingCheck_few: "{{count}} مستندات تنتظر التحقق، لذا لا تُحتسب بعد.",
      awaitingCheck_many: "{{count}} مستندًا ينتظر التحقق، لذا لا يُحتسب بعد.",
      awaitingCheck_other: "{{count}} مستندًا ينتظر التحقق، لذا لا يُحتسب بعد.",
    },
    risk: {
      on_track: "المخاطر منخفضة. تكفي العناية المعتادة والفحوصات المجدولة.",
      watch: "المخاطر متوسطة. التزم بمواعيد الفحوصات وراقب أي تغيير.",
      needs_attention: "المخاطر مرتفعة. العطل سيكون مكلفًا أو غير آمن، فاتبع الخطة أدناه.",
      notAssessed: "بدون تقييم للمخاطر، لا أحد يستطيع قول مدى أهمية أي عطل.",
      noLinks: "المخاطر {{level}}. لا توجد روابط مع أصول أخرى، لذا الآثار المتتابعة غير معروفة.",
      singlePoint: "تعتمد عليه أصول أخرى دون بديل، لذا يوقفها عطله أيضًا.",
    },
    condition: {
      on_track: "حالته جيدة ويُفحص في موعده.",
      watch: "بدأت حالته تتراجع. تابع الفحص القادم.",
      needs_attention: "حالته سيئة. خطّط للإصلاح أو الاستبدال.",
      none: "لا توجد درجة حالة محفوظة للحكم بها بعد.",
      neverInspected: "لم يفحصه أحد في التطبيق، لذا حالته تخمين حتى يُفحص.",
      issues_zero: "وجدت {{count}} فحوصات حديثة مشكلات تحتاج إلى متابعة.",
      issues_one: "وجد فحص حديث واحد مشكلات تحتاج إلى متابعة.",
      issues_two: "وجدت {{count}} فحوصات حديثة مشكلات تحتاج إلى متابعة.",
      issues_few: "وجدت {{count}} فحوصات حديثة مشكلات تحتاج إلى متابعة.",
      issues_many: "وجد {{count}} فحصًا حديثًا مشكلات تحتاج إلى متابعة.",
      issues_other: "وجد {{count}} فحصًا حديثًا مشكلات تحتاج إلى متابعة.",
      repeat: "«{{item}}» يتكرر باستمرار. إصلاح السبب يوفّر الزيارات المتكررة.",
    },
    work: {
      none: "عدم وجود مهام يعني إما أن لا شيء كان مطلوبًا أو أن الأعمال لا تُسجَّل في التطبيق.",
      ok: "تُنجز المهام في موعدها وصحيحة من أول مرة.",
      overdue: "المهام المتأخرة تترك مشكلات معروفة دون حل وترفع المخاطر.",
      rework: "المهام المرجعة تكلّف زيارة ثانية وتؤخر الإصلاح.",
    },
    contractors: {
      none: "لا توجد أعمال مقاولين مسجلة، لذا لا يمكن تقييم أدائهم.",
      good: "المقاولون ينجزون في الموعد وصحيحًا من أول مرة.",
      late_zero: "{{count}} مقاولين يتأخرون في الإنجاز غالبًا.",
      late_one: "مقاول واحد يتأخر في الإنجاز غالبًا.",
      late_two: "{{count}} مقاولين يتأخرون في الإنجاز غالبًا.",
      late_few: "{{count}} مقاولين يتأخرون في الإنجاز غالبًا.",
      late_many: "{{count}} مقاولاً يتأخرون في الإنجاز غالبًا.",
      late_other: "{{count}} مقاولاً يتأخرون في الإنجاز غالبًا.",
      sentBack_zero: "أُرجعت أعمال لـ {{count}} مقاولين.",
      sentBack_one: "أُرجعت أعمال لمقاول واحد.",
      sentBack_two: "أُرجعت أعمال لـ {{count}} مقاولين.",
      sentBack_few: "أُرجعت أعمال لـ {{count}} مقاولين.",
      sentBack_many: "أُرجعت أعمال لـ {{count}} مقاولاً.",
      sentBack_other: "أُرجعت أعمال لـ {{count}} مقاولاً.",
      offApp_zero: "{{count}} مقاولين لا يستخدمون التطبيق، لذا أعمالهم أقل توثيقًا.",
      offApp_one: "مقاول واحد لا يستخدم التطبيق، لذا أعماله أقل توثيقًا.",
      offApp_two: "{{count}} مقاولين لا يستخدمون التطبيق، لذا أعمالهم أقل توثيقًا.",
      offApp_few: "{{count}} مقاولين لا يستخدمون التطبيق، لذا أعمالهم أقل توثيقًا.",
      offApp_many: "{{count}} مقاولاً لا يستخدمون التطبيق، لذا أعمالهم أقل توثيقًا.",
      offApp_other: "{{count}} مقاولاً لا يستخدمون التطبيق، لذا أعمالهم أقل توثيقًا.",
    },
    property: {
      on_track: "العقار في حالة جيدة عمومًا.",
      watch: "العقار سليم في معظمه، مع بعض المناطق التي تحتاج متابعة.",
      needs_attention: "العقار يحتاج إلى اهتمام: الامتثال أو الحالة دون المستوى المطلوب.",
      truncated: "يضم هذا الموقع {{n}} أصول؛ يقرأ التقرير أول 5000 منها.",
    },
    areas: {
      none: "بدون مبانٍ أو مناطق، لا يستطيع التقرير إظهار أماكن تركّز المشكلات.",
      ok: "لا يبرز أي مبنى أو منطقة كمشكلة.",
      highRisk: "تتركّز الأصول عالية المخاطر في {{area}}. ابدأ من هناك.",
    },
    inspections: {
      on_track: "فُحصت معظم الأصول تقريبًا هذا العام.",
      watch: "بعض الأصول لم تُفحص هذا العام.",
      needs_attention: "كثير من الأصول لم تُفحص هذا العام، لذا حالتها غير معروفة.",
      none: "لا يوجد ملخص فحوصات للحكم به بعد.",
      overdue: "هناك فحوصات مجدولة متأخرة. استدركها قبل أن تفوتك مشكلات.",
    },
  },
  basis: {
    environment: {
      summary: "من الملخص الليلي للموقع بتاريخ {{date}}.",
      noSummary: "من سجل الموقع؛ ليس للموقع ملخص ليلي بعد.",
    },
    site: {
      summary: "من الملخص الليلي بتاريخ {{date}}.",
    },
    compliance: "من أرقام الليلة والمستندات المحفوظة ({{n}}).",
    risk: "من آخر تقييم للمخاطر والروابط مع الأصول الأخرى ({{links}}).",
    condition: "من أرقام الحالة الليلية والفحوصات الحديثة ({{n}}).",
    work: {
      year: "من مهام آخر 12 شهرًا ({{n}}).",
      ninetyDays: "من مهام آخر 90 يومًا ({{n}}).",
    },
    contractors: {
      year: "من مهام المقاولين في آخر 12 شهرًا ({{n}}).",
      ninetyDays: "من مهام المقاولين في آخر 90 يومًا ({{n}}).",
    },
    areas: "من الأماكن المسجلة في الموقع والأصول داخلها ({{n}}).",
    siteRisk: "من تقييمات مخاطر أصول الموقع ({{n}}).",
  },
  score: {
    compliance: {
      on_track: "سليم: المستندات مكتملة.",
      watch: "بعض المستندات مستحقة أو ناقصة.",
      needs_attention: "مستندات منتهية أو ناقصة.",
      none: "لا أرقام بعد.",
    },
    risk: {
      on_track: "مخاطر منخفضة.",
      watch: "مخاطر متوسطة.",
      needs_attention: "مخاطر مرتفعة.",
      none: "لم تُقيَّم.",
    },
    condition: {
      on_track: "حالة جيدة.",
      watch: "الحالة تتراجع.",
      needs_attention: "حالة سيئة.",
      none: "لا أرقام حالة بعد.",
    },
    inspectionsOnTime: {
      on_track: "الفحوصات المجدولة أُنجزت في موعدها.",
      watch: "بعض الفحوصات متأخرة.",
      needs_attention: "كثير من الفحوصات متأخرة.",
      none: "لا فحوصات مجدولة.",
    },
    inspectedThisYear: {
      on_track: "فُحصت معظم الأصول هذا العام.",
      watch: "بعض الأصول لم تُفحص هذا العام.",
      needs_attention: "كثير من الأصول لم تُفحص هذا العام.",
      none: "لا يوجد ملخص فحوصات بعد.",
    },
    rightFirstTime: {
      on_track: "الأعمال صحيحة من أول مرة.",
      watch: "بعض الأعمال أُرجعت.",
      needs_attention: "كثير من الأعمال أُرجعت.",
      none: "لا أعمال منجزة لتقييمها.",
    },
    overdueWork: {
      on_track: "لا شيء متأخر.",
      watch: "مهام تجاوزت موعدها: {{n}}.",
      needs_attention: "مهام تجاوزت موعدها: {{n}}.",
      none: "لا مهام مسجلة.",
    },
  },
  band: {
    posture: {
      on_track: "سليم",
      watch: "للمتابعة",
      needs_attention: "إجراء",
    },
    risk: {
      low: "منخفضة",
      medium: "متوسطة",
      high: "مرتفعة",
      extreme: "بالغة",
    },
  },
  verdict: {
    on_track: "على المسار: {{reason}}",
    watch: "يستحق المتابعة: {{reason}}",
    needs_attention: "يحتاج إلى اهتمام: {{reason}}",
    on_track_all: "على المسار: كل المؤشرات في حالة جيدة.",
  },
  reason: {
    compliance: "الامتثال عند {{value}}.",
    risk: "المخاطر عند {{value}} من 25.",
    condition: "الحالة عند {{value}}.",
    inspections_on_time: "{{value}}% من الفحوصات في موعدها.",
    right_first_time: "{{value}}% من الأعمال صحيحة من أول مرة.",
    overdue_work: "مهام تجاوزت موعدها: {{value}}.",
  },
  stat: {
    jobsWithSubJobs: "مهام لها مهام فرعية",
    familiesOnTime: "منها في الوقت المحدد",
    waitBetweenSteps: "الانتظار بين الخطوات",
    stepsSentBack: "خطوات أُعيدت",
    hoursValue: "{{n}} ساعة",
    assets: "الأصول",
    assetsAtRisk: "أصول معرّضة للخطر",
    checksDone: "فحوصات منجزة",
    checksNext60: "فحوصات مستحقة خلال 60 يومًا",
    checksOverdue: "فحوصات متأخرة",
    checksPlanned: "فحوصات مجدولة",
    expiredDocuments: "مستندات منتهية",
    failed90d: "فحوصات بها مشكلات (90 يومًا)",
    inspectedThisYear: "فُحصت هذا العام",
    inspections90d: "فحوصات (90 يومًا)",
    jobsDone: "مهام منجزة",
    links: "أصول مرتبطة",
    neighbours: "أصول قريبة",
    onTime: "في الموعد",
    openJobs: "مهام مفتوحة",
    overdueJobs: "مهام متأخرة",
    rejected: "مرفوضة",
    rescheduled: "أُعيدت جدولتها",
    rightFirstTime: "صحيح من أول مرة",
    sentBack: "مُرجعة",
    siteAtRisk: "أصول الموقع المعرّضة للخطر",
    siteCompliance: "امتثال الموقع",
    siteHealth: "حالة الموقع",
    siteOverdueJobs: "مهام الموقع المتأخرة",
  },
  col: {
    area: "المنطقة",
    asset: "الأصل",
    assets: "الأصول",
    avgDays: "متوسط الأيام",
    contractor: "المقاول",
    date: "التاريخ",
    document: "المستند",
    expires: "تنتهي في",
    highRisk: "مخاطر مرتفعة",
    issues: "المشكلات",
    job: "المهمة",
    jobs: "المهام",
    kind: "النوع",
    level: "المستوى",
    onTime: "في الموعد",
    reason: "السبب",
    result: "النتيجة",
    risk: "المخاطر",
    sentBack: "مُرجعة",
    site: "الموقع",
    status: "الحالة",
    usesApp: "يستخدم التطبيق",
  },
  visual: {
    areas: "المباني والمناطق",
    byZone: "الأصول حسب النطاق",
    childSites: "المواقع داخل هذا الموقع",
    complianceTrend: "الامتثال، آخر 90 يومًا",
    contractors: "المقاولون",
    documents: "المستندات",
    healthTrend: "الحالة، آخر 90 يومًا",
    openJobsTrend: "المهام المفتوحة، آخر 90 يومًا",
    recentInspections: "الفحوصات الحديثة",
    repeatItems: "أعطال متكررة",
    rework: "أسباب إرجاع الأعمال",
    riskTrend: "المخاطر، آخر 90 يومًا",
    topRisk: "الأصول الأعلى مخاطر",
  },
  docStatus: {
    awaitingCheck: "بانتظار التحقق",
    expired: "منتهي",
    expiring: "ينتهي قريبًا",
    valid: "ساري",
  },
  result: {
    issues: "وُجدت مشكلات",
    passed: "ناجح",
    open: "غير مكتمل",
  },
  common: {
    yes: "نعم",
    no: "لا",
    noReason: "لم يُذكر سبب",
    noExpiry: "بلا تاريخ انتهاء",
  },
  contractors: {
    anonymous: "المقاول {{letter}}",
  },
  action: {
    planReplacement: "خطط لاستبدال {{name}}",
    backup: "خطّط لبديل لـ {{name}}",
    clearOverdue_zero: "أنجز المهام المتأخرة الـ {{count}}",
    clearOverdue_one: "أنجز المهمة المتأخرة",
    clearOverdue_two: "أنجز المهام المتأخرة الـ {{count}}",
    clearOverdue_few: "أنجز المهام المتأخرة الـ {{count}}",
    clearOverdue_many: "أنجز المهام المتأخرة البالغ عددها {{count}}",
    clearOverdue_other: "أنجز المهام المتأخرة البالغ عددها {{count}}",
    fillDetails: "أكمل البيانات الناقصة",
    fillSiteDetails: "أكمل بيانات الموقع الناقصة",
    inspect: "افحص {{name}}",
    inspectRest_zero: "افحص الأصول الـ {{count}} التي لم تُفحص هذا العام",
    inspectRest_one: "افحص الأصل الوحيد الذي لم يُفحص هذا العام",
    inspectRest_two: "افحص الأصول الـ {{count}} التي لم تُفحص هذا العام",
    inspectRest_few: "افحص الأصول الـ {{count}} التي لم تُفحص هذا العام",
    inspectRest_many: "افحص الأصول التي لم تُفحص هذا العام وعددها {{count}}",
    inspectRest_other: "افحص الأصول التي لم تُفحص هذا العام وعددها {{count}}",
    overdueChecks_zero: "نفّذ الفحوصات المتأخرة الـ {{count}}",
    overdueChecks_one: "نفّذ الفحص المتأخر",
    overdueChecks_two: "نفّذ الفحوصات المتأخرة الـ {{count}}",
    overdueChecks_few: "نفّذ الفحوصات المتأخرة الـ {{count}}",
    overdueChecks_many: "نفّذ الفحوصات المتأخرة البالغ عددها {{count}}",
    overdueChecks_other: "نفّذ الفحوصات المتأخرة البالغ عددها {{count}}",
    renewExpired_zero: "جدّد الشهادات المنتهية الـ {{count}}",
    renewExpired_one: "جدّد الشهادة المنتهية",
    renewExpired_two: "جدّد الشهادات المنتهية الـ {{count}}",
    renewExpired_few: "جدّد الشهادات المنتهية الـ {{count}}",
    renewExpired_many: "جدّد الشهادات المنتهية البالغ عددها {{count}}",
    renewExpired_other: "جدّد الشهادات المنتهية البالغ عددها {{count}}",
    renewExpiring_zero: "جدّد الشهادات الـ {{count}} التي تنتهي قريبًا",
    renewExpiring_one: "جدّد الشهادة التي تنتهي قريبًا",
    renewExpiring_two: "جدّد الشهادات الـ {{count}} التي تنتهي قريبًا",
    renewExpiring_few: "جدّد الشهادات الـ {{count}} التي تنتهي قريبًا",
    renewExpiring_many: "جدّد الشهادات التي تنتهي قريبًا وعددها {{count}}",
    renewExpiring_other: "جدّد الشهادات التي تنتهي قريبًا وعددها {{count}}",
    repeatFault: "اعثر على سبب «{{item}}»",
    reviewRisk: "راجع مخاطر {{name}}",
    rework: "تحدّث مع المقاولين عن الأعمال المرجعة",
  },
  why: {
    pastLife: "تجاوز عمره المتوقع.",
    spendHigh: "كلفت إصلاحات سنة واحدة نصف ثمن الجديد أو أكثر.",
    backup: "تعتمد عليه أصول أخرى دون بديل.",
    clearOverdue: "المهام المتأخرة تترك مشكلات معروفة دون حل.",
    fillDetails: "جودة البيانات {{score}} من 100، ما يحدّ مما يمكن للتقرير قوله.",
    neverInspected: "حالته غير معروفة حتى يفحصه أحد.",
    overdueChecks: "تجاوزت فحوصات مجدولة موعدها.",
    renewExpired: "الشهادة المنتهية قد تجعل استخدامه غير قانوني أو غير مؤمَّن.",
    renewExpiring: "التجديد قبل الانتهاء يتجنب انقطاع التغطية.",
    repeatFault_zero: "احتاج إلى مهمة {{count}} مرات.",
    repeatFault_one: "احتاج إلى مهمة مرة واحدة من قبل.",
    repeatFault_two: "احتاج إلى مهمة {{count}} مرات.",
    repeatFault_few: "احتاج إلى مهمة {{count}} مرات.",
    repeatFault_many: "احتاج إلى مهمة {{count}} مرة.",
    repeatFault_other: "احتاج إلى مهمة {{count}} مرة.",
    reviewRisk: "مخاطره {{level}}.",
    rework_zero: "أُرجعت {{count}} مهام.",
    rework_one: "أُرجعت مهمة واحدة.",
    rework_two: "أُرجعت {{count}} مهام.",
    rework_few: "أُرجعت {{count}} مهام.",
    rework_many: "أُرجعت {{count}} مهمة.",
    rework_other: "أُرجعت {{count}} مهمة.",
  },
  jobTitle: {
    planReplacement: "التخطيط للاستبدال",
    findCause: "اعثر على سبب العطل المتكرر: {{item}}",
    renewCertificates: "تجديد الشهادات المنتهية",
    riskReview: "مراجعة المخاطر",
  },
  getMore: {
    addValue: "أضف تاريخ تركيبه ومدة عمره المتوقعة وكلفة استبداله، ليعرض التقرير عمره وقيمته.",
    addValueButton: "إضافة القيمة والعمر",
    addDetails: "أكمل البيانات الناقصة لرفع جودة البيانات وموثوقية كل قسم.",
    addDetailsButton: "تعديل الأصل",
    addSiteDetails: "أكمل بيانات الموقع الناقصة لرفع جودة البيانات.",
    addSiteDetailsButton: "تعديل الموقع",
    groupRule: "أنشئ قاعدة مجموعة لتحصل الأصول المماثلة على الفحوصات الصحيحة تلقائيًا.",
    groupRuleButton: "فتح قواعد المجموعات",
    inviteContractor: "ادعُ مقاوليك لتُسجَّل أعمالهم مع الأدلة.",
    inviteContractorButton: "دعوة مقاول",
    linkAssets: "اربطه بالأصول التي يعتمد عليها أو يخدمها لتظهر المخاطر المتتابعة.",
    linkAssetsButton: "إضافة روابط",
    placeAssets: "ضع أصول الموقع في مبانٍ ومناطق لتظهر المشكلات حسب المكان.",
    placeAssetsButton: "فتح الموقع",
    placeOnSite: "اربطه بموقع ليتمكن التقرير من وصف محيطه.",
    placeOnSiteButton: "اختيار موقع",
    scheduleInspection: "جدول فحصًا لتُعرف حالته.",
    scheduleInspectionButton: "جدولة فحص",
    siteAddress: "أضف عنوان الموقع أو موقعه على الخريطة.",
    siteAddressButton: "إضافة العنوان",
    uploadCertificate: "ارفع شهاداته ليمكن إثبات الامتثال.",
    uploadCertificateButton: "رفع مستند",
  },
  coverage: {
    asset: {
      site: "موقع",
      place: "مكانه",
      links: "روابط مع أصول أخرى",
      documents: "مستندات",
      inspection: "فحص هذا العام",
      risk: "تقييم للمخاطر",
      criticality: "الأهمية الحرجة",
      figures: "أرقام ليلية",
      work: "سجل المهام",
      schedule: "فحوصات مجدولة",
    },
    site: {
      address: "عنوان أو موقع على الخريطة",
      summary: "ملخص ليلي",
      areas: "مبانٍ ومناطق",
      inspected: "فحوصات لمعظم الأصول",
      assessed: "تقييمات مخاطر لمعظم الأصول",
      evidence: "أدلة لمعظم الأصول",
      contractors: "أعمال مقاولين",
      located: "مواقع الأصول على الخريطة",
    },
  },
  gaps: {
    missingField: "لا توجد قيمة لـ {{field}}.",
    neverInspected: "لم يُفحص قط، لذا حالته الحالية غير معروفة.",
    inspectedLongAgo: "آخر فحص قبل {{days}} يومًا، لذا ربما تغيّرت حالته.",
    noInspectionThisYear: "لم يكتمل أي فحص خلال آخر 12 شهرًا.",
    noDocuments: "لا توجد مستندات (شهادات، أدلة، ضمانات) محفوظة.",
    noPhotos: "لا توجد صور.",
    noRiskAssessment: "لم يُجرَ أي تقييم للمخاطر.",
    noSite: "غير مرتبط بموقع، لذا لا يمكن وصف محيطه.",
    noLocation: "لا يوجد موقع على الخريطة.",
    noLinks: "غير مرتبط بأي أصل ذي صلة، لذا الآثار المتتابعة غير معروفة.",
    retiredWithOpenJobs_zero: "مُعلَّم بأنه {{status}} لكن لديه {{count}} مهام مفتوحة.",
    retiredWithOpenJobs_one: "مُعلَّم بأنه {{status}} لكن لديه مهمة مفتوحة واحدة.",
    retiredWithOpenJobs_two: "مُعلَّم بأنه {{status}} لكن لديه {{count}} مهام مفتوحة.",
    retiredWithOpenJobs_few: "مُعلَّم بأنه {{status}} لكن لديه {{count}} مهام مفتوحة.",
    retiredWithOpenJobs_many: "مُعلَّم بأنه {{status}} لكن لديه {{count}} مهمة مفتوحة.",
    retiredWithOpenJobs_other: "مُعلَّم بأنه {{status}} لكن لديه {{count}} مهمة مفتوحة.",
    riskWithoutCriticality: "لديه درجة مخاطر لكن بلا أهمية حرجة، لذا تعتمد الدرجة على قيمة افتراضية.",
    zonesWithoutSite: "لديه نطاقات لكن بلا موقع، لذا لا تنتمي النطاقات إلى شيء.",
    noStoredFigures: "لا توجد أرقام يومية محفوظة بعد، لذا لا يمكن عرض الاتجاهات.",
    staleFigures: "عمر الأرقام اليومية المحفوظة {{days}} يومًا.",
    missingFieldOnAssets_zero: "لا توجد قيمة لـ {{field}} في {{count}} من أصل {{total}} أصول.",
    missingFieldOnAssets_one: "لا توجد قيمة لـ {{field}} في أصل واحد من أصل {{total}}.",
    missingFieldOnAssets_two: "لا توجد قيمة لـ {{field}} في {{count}} من أصل {{total}} أصول.",
    missingFieldOnAssets_few: "لا توجد قيمة لـ {{field}} في {{count}} من أصل {{total}} أصول.",
    missingFieldOnAssets_many: "لا توجد قيمة لـ {{field}} في {{count}} من أصل {{total}} أصلاً.",
    missingFieldOnAssets_other: "لا توجد قيمة لـ {{field}} في {{count}} من أصل {{total}} أصلاً.",
    noAssets: "لا توجد أصول في هذا الموقع.",
    assetsNotInspected_zero: "{{count}} من أصل {{total}} أصول لم تُفحص خلال آخر 12 شهرًا.",
    assetsNotInspected_one: "أصل واحد من أصل {{total}} لم يُفحص خلال آخر 12 شهرًا.",
    assetsNotInspected_two: "{{count}} من أصل {{total}} أصول لم تُفحص خلال آخر 12 شهرًا.",
    assetsNotInspected_few: "{{count}} من أصل {{total}} أصول لم تُفحص خلال آخر 12 شهرًا.",
    assetsNotInspected_many: "{{count}} من أصل {{total}} أصلاً لم تُفحص خلال آخر 12 شهرًا.",
    assetsNotInspected_other: "{{count}} من أصل {{total}} أصلاً لم تُفحص خلال آخر 12 شهرًا.",
    noInspectionHistory: "لا يوجد سجل فحوصات ملخّص لهذا الموقع بعد.",
    assetsWithNothing_zero: "{{count}} أصول لا يوجد لها أي سجل.",
    assetsWithNothing_one: "أصل واحد لا يوجد له أي سجل.",
    assetsWithNothing_two: "{{count}} أصول لا يوجد لها أي سجل.",
    assetsWithNothing_few: "{{count}} أصول لا يوجد لها أي سجل.",
    assetsWithNothing_many: "{{count}} أصلاً لا يوجد لها أي سجل.",
    assetsWithNothing_other: "{{count}} أصلاً لا يوجد لها أي سجل.",
    assetsNotAssessed_zero: "{{count}} أصول بلا تقييم للمخاطر.",
    assetsNotAssessed_one: "أصل واحد بلا تقييم للمخاطر.",
    assetsNotAssessed_two: "{{count}} أصول بلا تقييم للمخاطر.",
    assetsNotAssessed_few: "{{count}} أصول بلا تقييم للمخاطر.",
    assetsNotAssessed_many: "{{count}} أصلاً بلا تقييم للمخاطر.",
    assetsNotAssessed_other: "{{count}} أصلاً بلا تقييم للمخاطر.",
    siteNotLocated: "ليس للموقع عنوان ولا موقع على الخريطة.",
    assetsNotLocated_zero: "{{count}} من أصل {{total}} أصول بلا موقع على الخريطة.",
    assetsNotLocated_one: "أصل واحد من أصل {{total}} بلا موقع على الخريطة.",
    assetsNotLocated_two: "{{count}} من أصل {{total}} أصول بلا موقع على الخريطة.",
    assetsNotLocated_few: "{{count}} من أصل {{total}} أصول بلا موقع على الخريطة.",
    assetsNotLocated_many: "{{count}} من أصل {{total}} أصلاً بلا موقع على الخريطة.",
    assetsNotLocated_other: "{{count}} من أصل {{total}} أصلاً بلا موقع على الخريطة.",
    noSiteSummary: "لا يوجد ملخص محفوظ للموقع بعد، لذا لا يمكن عرض الاتجاهات.",
    staleSiteSummary: "عمر ملخص الموقع المحفوظ {{days}} يومًا.",
    assetCountMoved_zero: "يضم الموقع الآن {{count}} أصول، لكن ملخص الليلة الماضية أحصى {{summarised}}.",
    assetCountMoved_one: "يضم الموقع الآن أصلاً واحدًا، لكن ملخص الليلة الماضية أحصى {{summarised}}.",
    assetCountMoved_two: "يضم الموقع الآن {{count}} أصول، لكن ملخص الليلة الماضية أحصى {{summarised}}.",
    assetCountMoved_few: "يضم الموقع الآن {{count}} أصول، لكن ملخص الليلة الماضية أحصى {{summarised}}.",
    assetCountMoved_many: "يضم الموقع الآن {{count}} أصلاً، لكن ملخص الليلة الماضية أحصى {{summarised}}.",
    assetCountMoved_other: "يضم الموقع الآن {{count}} أصلاً، لكن ملخص الليلة الماضية أحصى {{summarised}}.",
    assetsRiskWithoutCriticality_zero: "{{count}} أصول لديها درجة مخاطر بلا أهمية حرجة.",
    assetsRiskWithoutCriticality_one: "أصل واحد لديه درجة مخاطر بلا أهمية حرجة.",
    assetsRiskWithoutCriticality_two: "{{count}} أصول لديها درجة مخاطر بلا أهمية حرجة.",
    assetsRiskWithoutCriticality_few: "{{count}} أصول لديها درجة مخاطر بلا أهمية حرجة.",
    assetsRiskWithoutCriticality_many: "{{count}} أصلاً لديها درجة مخاطر بلا أهمية حرجة.",
    assetsRiskWithoutCriticality_other: "{{count}} أصلاً لديها درجة مخاطر بلا أهمية حرجة.",
  },
  versions: {
    title: "الإصدارات",
    hint: "يبقى كل إصدار محفوظ كما كان تمامًا. افتح أحدها لقراءته أو مقارنته بالإصدار السابق.",
    none: "لا توجد إصدارات محفوظة بعد. احفظ هذا الإصدار، أو اطلب نسخة الذكاء الاصطناعي، لبدء القائمة.",
    save: "حفظ هذا الإصدار",
    saveFailed: "تعذّر حفظ الإصدار",
    savedTitle: "تم الحفظ",
    savedBody: "حُفظ بوصفه الإصدار {{version}}.",
    label: "الإصدار {{version}} · {{date}}",
    ai: "كتبه الذكاء الاصطناعي",
    app: "أرقام التطبيق",
    open: "فتح",
    close: "إغلاق",
    viewing: "أنت تقرأ الإصدار {{version}}، المحفوظ في {{date}}.",
    backToCurrent: "العودة إلى التقرير الحالي",
  },
  compare: {
    title: "ما الذي تغيّر من الإصدار {{older}} إلى الإصدار {{newer}}",
    show: "المقارنة بالإصدار {{version}}",
    hide: "إخفاء المقارنة",
    verdict: "الحكم العام: {{before}} ← {{after}} ({{movement}})",
    dataQuality: "جودة البيانات: {{before}} ← {{after}} ({{movement}})",
    figure: "{{before}} ← {{after}} ({{movement}})",
    actionsAdded: "إجراءات جديدة: {{n}}",
    actionsGone: "إجراءات لم تعد لازمة: {{n}}",
    bullet: "• {{text}}",
    movement: {
      better: "أفضل",
      worse: "أسوأ",
      same: "دون تغيير",
      new: "جديد",
      gone: "لم يعد ظاهرًا",
    },
  },
  share: {
    open: "مشاركة",
    title: "مشاركة هذا التقرير",
    hint: "يُبلَّغ الشخص في التطبيق وبالبريد الإلكتروني. يفتح الرابط التقرير في AssetWRX: الغلاف وبطاقة الأداء فورًا، والباقي بعد تسجيل الدخول أو إنشاء حساب مجاني.",
    toLabel: "إرسال إلى",
    toPlaceholder: "ابحث في جهات الاتصال أو اكتب بريدًا إلكترونيًا",
    messageLabel: "الرسالة (اختياري)",
    messagePlaceholder: "إضافة ملاحظة للمستلم...",
    savesFirst: "يُحفظ ما على الشاشة أولًا كإصدار جديد، ليقرأ هذا بالضبط.",
    send: "إرسال التقرير",
    sentTitle: "تمت المشاركة",
    sentBody: "تمت مشاركة الإصدار {{version}} مع {{who}}.",
    failedTitle: "تعذّرت المشاركة",
    failedBody: "حدث خطأ. حاول مرة أخرى.",
    sharedWith: "تمت المشاركة مع",
    versionOn: "الإصدار {{version}} · {{date}}",
    read: "قُرئ في {{date}}",
    notRead: "لم يُقرأ بعد",
    withdrawn: "سُحب",
    replaced: "استُبدل بإصدار أحدث",
    sendNew: "إرسال الإصدار {{version}}",
    withdraw: "سحب",
    close: "إغلاق",
  },
  download: {
    pdf: "تنزيل PDF",
    csv: "تنزيل CSV",
    approverOnly: "التنزيل متاح فقط لمن يعتمد الأعمال على هذا الأصل. استخدم «مشاركة» لإرساله إلى شخص ما.",
  },
  csv: {
    similarMiddle: "وسط المماثلة",
    basis: "على أساس",
    part: "الجزء",
    item: "البند",
    value: "القيمة",
    band: "التقييم",
    note: "ملاحظة",
    subject: "الموضوع",
    version: "الإصدار",
    written: "تاريخ الكتابة",
    reader: "مكتوب لـ",
  },
  shared: {
    header: "تقرير مُشارك",
    loadFailed: "تعذّر تحميل التقرير.",
    notFound: "هذا الرابط لا يقود إلى أي تقرير.",
    goToApp: "الانتقال إلى AssetWRX",
    revoked: "لم يعد هذا التقرير مُشاركًا معك.",
    replaced: "تمت مشاركة إصدار أحدث من هذا التقرير معك.",
    openNewer: "فتح الإصدار الأحدث",
    notYours: "تمت مشاركة هذا التقرير مع شخص آخر. سجّل الدخول بالعنوان الذي أُرسل إليه.",
    verdict: "الحكم العام: {{rating}}",
    gateTitle: "اقرأ التقرير كاملًا",
    gateBody: "سجّل الدخول، أو أنشئ حسابًا مجانيًا، لقراءة كل الأقسام وخطة العمل وجودة البيانات.",
    signIn: "تسجيل الدخول",
    createAccount: "إنشاء حساب مجاني",
    sharedBy: "شاركه {{who}} في {{date}}",
    sharedOn: "تمت المشاركة في {{date}}",
    note: "رسالته: {{message}}",
    newerExists: "يوجد إصدار أحدث (الإصدار {{version}}). اطلبه من المرسل إن احتجت إليه.",
    readOnly: "للقراءة فقط. يبقى هذا التقرير كما كان عند مشاركته.",
  },
  comparison: {
    title: "المقارنة",
    measure: {
      compliance: "الامتثال",
      condition: "الحالة",
      risk: "المخاطر",
      right_first_time: "الصواب من المرة الأولى",
    },
    position: {
      better: "أفضل من معظمها",
      similar: "مثل معظمها تقريبًا",
      worse: "خلف معظمها",
    },
    row: "{{value}}، {{position}} (وسط المماثلة: {{middle}})",
    notEnough: "عدد قليل جدًا من المماثلة لديه هذا الرقم للمقارنة.",
    basis: {
      asset_zero: "مقارنة بـ {{count}} أصول مماثلة يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      asset_one: "مقارنة بأصل مماثل واحد يمكنك رؤيته، وفق أرقام الليلة الماضية.",
      asset_two: "مقارنة بأصلين مماثلين يمكنك رؤيتهما، وفق أرقام الليلة الماضية.",
      asset_few: "مقارنة بـ {{count}} أصول مماثلة يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      asset_many: "مقارنة بـ {{count}} أصلًا مماثلًا يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      asset_other: "مقارنة بـ {{count}} أصل مماثل يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      site_zero: "مقارنة بـ {{count}} مواقع أخرى يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      site_one: "مقارنة بموقع آخر واحد يمكنك رؤيته، وفق أرقام الليلة الماضية.",
      site_two: "مقارنة بموقعين آخرين يمكنك رؤيتهما، وفق أرقام الليلة الماضية.",
      site_few: "مقارنة بـ {{count}} مواقع أخرى يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      site_many: "مقارنة بـ {{count}} موقعًا آخر يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
      site_other: "مقارنة بـ {{count}} موقع آخر يمكنك رؤيتها، وفق أرقام الليلة الماضية.",
    },
    finding: {
      behind: "خلف معظم المماثلة في {{measure}}.",
      ahead: "متقدم على معظم المماثلة في {{measure}}.",
      inLine: "متماشٍ مع المماثلة.",
    },
  },
  value: {
    title: "القيمة والعمر",
    measure: {
      installed_on: "تاريخ التركيب",
      age: "العمر",
      expected_life: "العمر المتوقع",
      remaining_life: "العمر المتبقي",
      purchase_cost: "كلفة الشراء",
      replacement_cost: "كلفة الاستبدال",
      spend: "المنفق على الأعمال",
      spend_share: "الإنفاق نسبةً إلى كلفة الاستبدال",
      replacement_total: "قيمة الاستبدال المسجلة",
      assets_with_value: "أصول لها كلفة استبدال",
      past_life: "أصول تجاوزت عمرها المتوقع",
    },
    years_zero: "{{value}} سنة",
    years_one: "{{value}} سنة",
    years_two: "{{value}} سنة",
    years_few: "{{value}} سنوات",
    years_many: "{{value}} سنة",
    years_other: "{{value}} سنة",
    lifeUsed: "استُهلك {{pct}}% من عمره المتوقع",
    finding: {
      pastLife: "تجاوز عمره المتوقع بـ {{years}} سنة.",
      spendHigh: "كلفت أعمال سنة واحدة {{pct}}% من كلفة استبداله. قد يكون الاستبدال أرخص من الإصلاح.",
      nearEnd: "استهلك {{pct}}% من عمره المتوقع.",
      lifeLeft: "بقي نحو {{years}} سنة من عمره المتوقع.",
      recorded: "ما سُجّل عن قيمته.",
      sitePastLife_zero: "{{count}} من {{of}} أصول لها عمر مسجل تجاوزته.",
      sitePastLife_one: "أصل واحد من {{of}} أصول لها عمر مسجل تجاوزه.",
      sitePastLife_two: "أصلان من {{of}} أصول لها عمر مسجل تجاوزاه.",
      sitePastLife_few: "{{count}} من {{of}} أصول لها عمر مسجل تجاوزته.",
      sitePastLife_many: "{{count}} من {{of}} أصول لها عمر مسجل تجاوزته.",
      sitePastLife_other: "{{count}} من {{of}} أصول لها عمر مسجل تجاوزته.",
      siteRecorded_zero: "{{count}} من {{of}} أصول لها كلفة استبدال مسجلة.",
      siteRecorded_one: "أصل واحد من {{of}} له كلفة استبدال مسجلة.",
      siteRecorded_two: "أصلان من {{of}} لهما كلفة استبدال مسجلة.",
      siteRecorded_few: "{{count}} من {{of}} أصول لها كلفة استبدال مسجلة.",
      siteRecorded_many: "{{count}} من {{of}} أصول لها كلفة استبدال مسجلة.",
      siteRecorded_other: "{{count}} من {{of}} أصول لها كلفة استبدال مسجلة.",
      siteSpendOnly: "ما كلفته أعمال الموقع.",
    },
    spendBasis: {
      year: "الإنفاق خلال آخر 12 شهرًا، من {{withCost}} من {{jobs}} أعمال منجزة لها كلفة.",
      ninetyDays: "الإنفاق خلال آخر 90 يومًا، من {{withCost}} من {{jobs}} أعمال منجزة لها كلفة.",
    },
    marketTitle: "سعر السوق المعتاد",
    marketHint: "من مصادر على الإنترنت، لم تتحقق منه AssetWRX.",
  },
esg: {
section: "الطاقة والكربون والاستدامة (ESG)",
basis: "من قراءات العدادات خلال آخر 24 شهرًا، وغازات التبريد وشهادات الطاقة المسجلة، وعوامل الكربون الصادرة عن الحكومة البريطانية ({{year}}). الكربون تقدير.",
ratingsTable: "شهادات الطاقة",
col: {
certificate: "الشهادة",
rating: "التصنيف",
},
finding: {
belowMinimum: "شهادات طاقة دون الحد الأدنى للتأجير (E): {{n}}.",
fgasOverdue: "فحوص تسرّب الغازات المفلورة المتأخرة: {{n}}.",
noMeters: "لا توجد عدادات طاقة مسجلة، لذا لا يمكن قياس الطاقة والكربون.",
energyChange: "استُخدم {{kwh}} كيلوواط ساعة خلال آخر 12 شهرًا ({{change}}% مقارنة بالعام السابق)، أي نحو {{tonnes}} طن CO₂e.",
energy: "استُخدم {{kwh}} كيلوواط ساعة خلال آخر 12 شهرًا، أي نحو {{tonnes}} طن CO₂e.",
},
meaning: {
belowMinimum: "لا يجوز تأجير مبنى في إنجلترا وويلز بتصنيف دون E دون إعفاء. خطّط للتحسين أو سجّل إعفاءً.",
fgasOverdue: "الفحوص المتأخرة تخالف قواعد الغازات المفلورة وتسمح بتسرّب غاز التبريد، وهو غاز دفيئة قوي، دون ملاحظة.",
noMeters: "بدون عدادات يبقى استهلاك الطاقة والكربون مجهولًا. أضف عدادات وسجّل القراءات.",
noFloorArea: "أضف المساحة لمقارنة الاستهلاك لكل م² مع المباني الأخرى.",
ok: "تُقاس الطاقة والكربون. حافظ على انتظام القراءات لتبقى الأرقام كاملة.",
},
stat: {
energy: "الطاقة، ك.و.س (12 شهرًا)",
change: "التغيّر السنوي، %",
intensity: "ك.و.س لكل م²",
carbon: "الكربون، طن CO₂e",
scope1: "النطاق 1، طن CO₂e",
scope2: "النطاق 2، طن CO₂e",
water: "الماء، م³",
meters: "عدادات مقروءة",
refrigerant: "غاز التبريد، طن CO₂e",
fgasOverdue: "فحوص الغازات المفلورة المتأخرة",
},
status: {
belowMinimum: "دون الحد الأدنى للتأجير",
expired: "منتهية",
expiresSoon: "تنتهي خلال 6 أشهر",
valid: "سارية",
},
action: {
improveEpc: "خطّط لأعمال ترفع تصنيف الطاقة إلى E أو أفضل",
fgasOverdue: "نفّذ فحوص التسرّب المتأخرة ({{n}})",
renewEpc: "جدّد شهادة الطاقة المنتهية",
readMeters: "سجّل قراءات العدادات التي لا قراءة لها منذ 3 أشهر ({{n}})",
},
why: {
improveEpc: "دون E لا يجوز تأجيره قانونًا دون إعفاء.",
fgasOverdue: "فحوص التسرّب واجب قانوني بهذه الكمية من غاز التبريد.",
renewEpc: "شهادة الطاقة مطلوبة للبيع أو التأجير.",
readMeters: "الفجوات في القراءات تجعل أرقام الطاقة والكربون ناقصة.",
},
jobTitle: {
improveEpc: "أعمال تحسين تصنيف الطاقة",
renewEpc: "تجديد شهادة أداء الطاقة",
},
},
};
